import { useBookingV2 } from "context/BookingV2Context"
import SelectSeat from "./SelectSeat"
import SelectSeatV2 from "./SelectSeatV2"
import { isEidPartyEvent } from "utils/helpers/constants"


const SelectSeatWrapper = () => {
    const { event } = useBookingV2()

    const isEid = isEidPartyEvent(event?._id)

    // Render SelectSeatV2 for Eid events, otherwise render SelectSeat
    return isEid ? <SelectSeatV2 /> : <SelectSeat />
}

export default SelectSeatWrapper
